// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"281":"newcar","471":"activity","535":"login","759":"carDetail","826":"index","942":"article","979":"oldcar"}[chunkId] + "." + {"281":"397c3ff6","471":"9ca80bf1","535":"de0613bc","759":"26d471c8","826":"9e688089","942":"06ecfc32","979":"5801474b"}[chunkId] + ".js";
};